// extracted by mini-css-extract-plugin
export default {"rotate":"RotateMessage_rotate__upick","phone":"RotateMessage_phone__DFZIw","message":"RotateMessage_message__t9v5s"};